/* Fix policy email on privacy page */
if (window.location.pathname.includes('/policies/privacy-policy')) {
  document.addEventListener('DOMContentLoaded', function () {
    document.body.innerHTML = document.body.innerHTML.replace(/sami89240@gmail\.com/g, 'info@maineverystorykept.com');
  });
}

document.addEventListener('DOMContentLoaded', function () {

  /* Mobile nav */
  var burger = document.querySelector('.hamburger');
  var nav    = document.querySelector('.header-nav');
  if (burger && nav) {
    burger.addEventListener('click', function () { nav.classList.toggle('nav-open'); });
    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target) && !burger.contains(e.target)) nav.classList.remove('nav-open');
    });
  }

  /* FAQ accordion */
  document.querySelectorAll('.faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item   = this.closest('.faq-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function (i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

});
